/** Stable anchor IDs for /help#article-id — used by HelpArticleLink and user guide content. */
export const HELP_ARTICLES = {
  // 1. Quick start
  QUICK_START_WHAT: 'quick-start-what-is-ima-one',
  QUICK_START_REGISTER: 'quick-start-register-account',
  QUICK_START_LOGIN: 'quick-start-login',
  QUICK_START_FORGOT_PASSWORD: 'quick-start-forgot-password',
  QUICK_START_UI_LAYOUT: 'quick-start-ui-layout',
  QUICK_START_SWITCH_LANGUAGE: 'quick-start-switch-language',
  QUICK_START_JOIN_TEAM: 'quick-start-join-team',
  QUICK_START_SELECT_PLACE: 'quick-start-select-place',
  QUICK_START_ENABLE_SERVICES: 'quick-start-enable-services',
  QUICK_START_RECOMMENDED_FLOW: 'quick-start-recommended-flow',

  // 2. Account
  ACCOUNT_PERSONAL_VS_TEAM: 'account-personal-vs-team',
  ACCOUNT_UNDERSTAND_ROLES: 'account-understand-roles',
  ACCOUNT_ADMIN_PERMISSIONS: 'account-admin-permissions',
  ACCOUNT_EDITOR_VIEWER: 'account-editor-viewer',
  ACCOUNT_INVITE_MEMBER: 'account-invite-member',
  ACCOUNT_FIX_PERMISSION_DENIED: 'account-fix-permission-denied',
  ACCOUNT_UPDATE_PROFILE: 'account-update-profile',
  ACCOUNT_EMAIL_VERIFICATION: 'account-email-verification',
  ACCOUNT_SWITCH_CONTEXT: 'account-switch-context',
  ACCOUNT_SECURITY_PRACTICES: 'account-security-practices',

  // 3. Dashboard
  DASHBOARD_WHAT_SHOWS: 'dashboard-what-shows',
  DASHBOARD_READ_KPI: 'dashboard-read-kpi',
  DASHBOARD_OPEN_NOTIFICATIONS: 'dashboard-open-notifications',
  DASHBOARD_USE_MAILBOX: 'dashboard-use-mailbox',
  DASHBOARD_FIND_TASKS: 'dashboard-find-tasks',
  DASHBOARD_ENTER_PROJECT: 'dashboard-enter-project',
  DASHBOARD_SWITCH_SITE: 'dashboard-switch-site',
  DASHBOARD_ALERT_SUMMARY: 'dashboard-alert-summary',
  DASHBOARD_SHORTCUTS: 'dashboard-shortcuts',
  DASHBOARD_MOBILE_LAYOUT: 'dashboard-mobile-layout',

  // 4. Places
  PLACES_WHAT_IS_SITE: 'places-what-is-site',
  PLACES_CREATE_SITE: 'places-create-site',
  PLACES_METER_ID_RULES: 'places-meter-id-rules',
  PLACES_DEVICE_TABLE_NAMING: 'places-device-table-naming',
  PLACES_GATEWAY_DATA_SOURCE: 'places-gateway-data-source',
  PLACES_ENABLE_PRICING: 'places-enable-pricing-service',
  PLACES_ENABLE_POWER: 'places-enable-power-service',
  PLACES_MANAGE_MEMBERS: 'places-manage-members',
  PLACES_EDIT_SITE_INFO: 'places-edit-site-info',
  PLACES_NO_DEVICE_DATA: 'places-no-device-data',

  // 5. Plot
  PLOT_EDIT_VS_VIEW: 'plot-edit-vs-view',
  PLOT_UNLOCK_ELEMENTS: 'plot-unlock-elements',
  PLOT_DEVICE_ID_FIVE_DIGIT: 'plot-device-id-five-digit',
  PLOT_BIND_SQL_COLUMN: 'plot-bind-sql-column',
  PLOT_GATEWAY_OVERVIEW: 'plot-gateway-overview',
  PLOT_GATEWAY_LOGIC: 'plot-gateway-logic-script',
  PLOT_REALTIME_VALUES: 'plot-realtime-values',
  PLOT_HISTORY_TOOLTIP: 'plot-history-and-tooltip',
  PLOT_EXPORT_CSV: 'plot-export-csv',
  PLOT_HEALTH_OVERLAY: 'plot-health-overlay',

  // 6. Price
  PRICE_SERVICE_OVERVIEW: 'price-service-overview',
  PRICE_TARIFF_STRUCTURE: 'price-tariff-structure',
  PRICE_TIME_OF_USE: 'price-time-of-use-rates',
  PRICE_BASELINE_UP: 'price-baseline-up-meaning',
  PRICE_BILLING_CYCLE: 'price-set-billing-cycle',
  PRICE_RUN_ESTIMATE: 'price-run-estimate',
  PRICE_LINK_POWER: 'price-link-to-power-mgmt',
  PRICE_RECALC_BASELINE: 'price-recalculate-baseline',
  PRICE_IMPORT_BILL: 'price-import-utility-bill',
  PRICE_TROUBLESHOOT: 'price-troubleshoot-missing',

  // 7. Power
  POWER_SERVICE_OVERVIEW: 'power-service-overview',
  POWER_ADD_GROUP: 'power-add-device-group',
  POWER_BIND_DEVICE: 'power-bind-device-switch',
  POWER_VARIABLE_BINDING: 'power-variable-binding',
  POWER_BASELINE_FORMULA: 'power-baseline-formula',
  POWER_ACTUAL_FORMULA: 'power-actual-formula',
  POWER_WEEKLY_SCHEDULE: 'power-weekly-schedule',
  POWER_GAP_FILL: 'power-gap-fill-algorithm',
  POWER_UNIT_PRICE: 'power-unit-price-formula',
  POWER_ISSUE_INVOICE: 'power-issue-invoice',

  // 8. Devices
  DEVICES_HEALTH_MEANING: 'devices-health-meaning',
  DEVICES_OPEN_MONITOR: 'devices-open-monitor',
  DEVICES_READ_TRENDS: 'devices-read-trends',
  DEVICES_SET_THRESHOLD: 'devices-set-threshold',
  DEVICES_HANDLE_OFFLINE: 'devices-handle-offline',
  DEVICES_EXPORT_HISTORY: 'devices-export-history',
  DEVICES_SAMPLE_RATE: 'devices-understand-sample-rate',
  DEVICES_TABLE_ID_FORMAT: 'devices-table-id-format',
  DEVICES_MULTI_METER: 'devices-multi-meter',
  DEVICES_MISSING_VALUES: 'devices-fix-missing-values',

  // 9. Imaginus
  IMAGINUS_WHAT: 'imaginus-what-it-does',
  IMAGINUS_START_CHAT: 'imaginus-start-chat',
  IMAGINUS_ASK_DATA: 'imaginus-ask-energy-data',
  IMAGINUS_SITE_CONTEXT: 'imaginus-site-context',
  IMAGINUS_PRIVACY: 'imaginus-privacy-scope',
  IMAGINUS_CANNOT_ACTIONS: 'imaginus-cannot-do-actions',
  IMAGINUS_PERSONAL_ENTRY: 'imaginus-personal-entry',
  IMAGINUS_TEAM_ENTRY: 'imaginus-team-entry',
  IMAGINUS_WHEN_WRONG: 'imaginus-when-wrong',
  IMAGINUS_FEEDBACK: 'imaginus-give-feedback',

  // 10. Alerts
  ALERTS_HOW_RULES: 'alerts-how-rules-work',
  ALERTS_CREATE_RULE: 'alerts-create-rule',
  ALERTS_SEVERITY: 'alerts-severity-levels',
  ALERTS_EMAIL: 'alerts-email-setup',
  ALERTS_LINE: 'alerts-line-setup',
  ALERTS_HISTORY: 'alerts-view-history',
  ALERTS_FALSE_ALARM: 'alerts-reduce-false-alarm',
  ALERTS_OFFLINE: 'alerts-offline-alert',
  ALERTS_TUNE_THRESHOLD: 'alerts-tune-threshold',
  ALERTS_HANDOFF: 'alerts-handoff-workflow',

  // 11. Reports
  REPORTS_TYPES: 'reports-types-available',
  REPORTS_MONTHLY: 'reports-monthly-summary',
  REPORTS_RECONCILIATION: 'reports-reconciliation-export',
  REPORTS_CSV: 'reports-csv-download',
  REPORTS_POWER_PERIOD: 'reports-power-period-report',
  REPORTS_DATE_RANGE: 'reports-filter-date-range',
  REPORTS_PRINT: 'reports-print-page',
  REPORTS_SCHEDULED: 'reports-scheduled-email',
  REPORTS_SHARE: 'reports-share-with-team',
  REPORTS_EMPTY: 'reports-empty-result',

  // 12. Desktop
  DESKTOP_WHY: 'desktop-why-use',
  DESKTOP_DOWNLOAD: 'desktop-download-page',
  DESKTOP_INSTALL: 'desktop-install-steps',
  DESKTOP_SIGN_IN: 'desktop-sign-in',
  DESKTOP_VS_WEB: 'desktop-compare-web',
  DESKTOP_UPDATE: 'desktop-auto-update',
  MOBILE_BROWSERS: 'mobile-supported-browsers',
  MOBILE_PLOT: 'mobile-plot-gestures',
  MOBILE_LIMITS: 'mobile-limits',
  DESKTOP_OFFLINE: 'desktop-offline-behavior',

  // 13. FAQ
  FAQ_LOGIN: 'faq-login-failed',
  FAQ_PLOT_NO_DATA: 'faq-plot-no-data',
  FAQ_HISTORY_EMPTY: 'faq-history-empty',
  FAQ_FORMULA: 'faq-formula-error',
  FAQ_BILLING: 'faq-billing-blocked',
  FAQ_UI_CLIPPED: 'faq-ui-clipped',
  FAQ_SLOW: 'faq-slow-performance',
  FAQ_WRONG_PLACE: 'faq-wrong-place-id',
  FAQ_FORBIDDEN: 'faq-403-forbidden',
  FAQ_CACHE: 'faq-clear-browser-cache',

  // 14. Support
  SUPPORT_EMAIL: 'support-contact-email',
  SUPPORT_LINE: 'support-contact-line',
  SUPPORT_PHONE: 'support-phone-hours',
  SUPPORT_INFO: 'support-info-to-provide',
  SUPPORT_SCREENSHOT: 'support-screenshot-tips',
  SUPPORT_RESPONSE: 'support-expected-response',
  SUPPORT_TRAINING: 'support-request-training',
  SUPPORT_FEATURE: 'support-feature-request',
  SUPPORT_BUG: 'support-report-bug',
  SUPPORT_FORM: 'support-use-contact-form',
} as const;

export type HelpArticleId = (typeof HELP_ARTICLES)[keyof typeof HELP_ARTICLES];

export function helpArticlePath(articleId: HelpArticleId | string): string {
  return `/help#${articleId}`;
}
